import { ReactNode } from 'react';
import { MajorTestKind } from '../types';
import HarmonyContent from './HarmonyContent';
import MeaningContent from './MeaningContent';
import NeedsContent from './NeedsContent';
import NeedsProContent from './NeedsProContent';
import PreferenceContent from './PreferenceContent';
import StudyContent from './StudyContent';

type RenderMajorTestContentParams = {
  kind: MajorTestKind;
  myResult: any;
  resultId: number;
  onContactClick: () => void;
  onResultUpdated?: () => void;
};

export const renderMajorTestContent = ({
  kind,
  myResult,
  resultId,
  onContactClick,
  onResultUpdated,
}: RenderMajorTestContentParams): ReactNode => {
  const sharedProps = { myResult, resultId, onContactClick };

  switch (kind) {
    case 'meaning':
      return <MeaningContent {...sharedProps} />;
    case 'needs':
      return <NeedsContent {...sharedProps} />;
    case 'needsPro':
      return <NeedsProContent {...sharedProps} />;
    case 'preference':
      return <PreferenceContent {...sharedProps} onResultUpdated={onResultUpdated} />;
    case 'preferenceJeune':
      return <PreferenceContent {...sharedProps} isPrefJeune={true} />;
    case 'harmony':
      return <HarmonyContent {...sharedProps} />;
    case 'study':
      return <StudyContent {...sharedProps} />;
    default:
      return null;
  }
};
